import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AssetDto, AssetVersionDto, AssetVideoTypeDataDto } from '@nusign/picflow-backend-types';
import { combineLatest, switchMap } from 'rxjs';
import { VideoThumbnailService } from '../../../services/video-thumbnail.service';
import { AssetVersionUrlPipe } from '../../../shared/pipes/asset-version-url.pipe';
import { FloorPipe } from '../../../shared/pipes/floor.pipe';

@Component({
  selector: 'app-video-thumbnail',
  templateUrl: './video-thumbnail.component.html',
  styleUrls: ['./video-thumbnail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FloorPipe, AssetVersionUrlPipe, DecimalPipe],
})
export class VideoThumbnailComponent {
  private videoThumbnailService = inject(VideoThumbnailService);
  readonly currentTime = input.required<number>();
  readonly asset = input.required<AssetDto>();
  readonly assetVersion = input.required<AssetVersionDto>();
  readonly constrainWidth = input<boolean>(undefined);
  readonly showTime = input<boolean>(undefined);
  readonly thumbnailInfo = toSignal(
    combineLatest([toObservable(this.assetVersion), toObservable(this.currentTime)]).pipe(
      switchMap(([assetVersion, currentTime]) => {
        return this.videoThumbnailService.getThumbnail(
          assetVersion.uuid,
          assetVersion.original_key,
          (assetVersion.data as AssetVideoTypeDataDto).width,
          (assetVersion.data as AssetVideoTypeDataDto).width,
          currentTime,
          (assetVersion.data as AssetVideoTypeDataDto).duration
        );
      })
    )
  );

  readonly loading = computed(() => {
    return this.thumbnailInfo() === undefined;
  });

  readonly isVertical = computed(() => {
    const info = this.thumbnailInfo();
    return info?.width < info?.height;
  });
}
